import { FormProps, notification } from "antd";
import { Form } from "antd";
import { useNavigate } from "react-router-dom";
import { postUserCreateThunk } from "tm-shared/api";

import BaseButton from "@/components/BaseButton";
import Header from "@/components/Header";
import { MainContainer } from "@/components/Layout/Styled";
import Meta from "@/components/Meta";
import { useAppDispatch } from "@/hooks/redux";

import { StyledInput, StyledSelect } from "./Styled";

type FieldType = {
    role: string;
    phone: string;
    firstName: string;
    lastName: string;
    externalId: string;
    managerId: string;
    email?: string;
};

const formList = [
    {
        value: "ta",
        label: "Торговий Агент",
    },
    {
        value: "sv",
        label: "Супервайзер",
    },
    {
        value: "hr",
        label: "HR",
    },
    {
        value: "md",
        label: "Мерчендайзер",
    },
    {
        value: "svm",
        label: "Супервайзер мерчендайзерів",
    },
    {
        value: "kam",
        label: "КАМ",
    },
    {
        value: "pctl",
        label: "Фотоконтролер",
    },
    {
        value: "analyst",
        label: "Аналітик",
    },
];

function AddUser() {
    const [form] = Form.useForm();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const onFinish: FormProps<FieldType>["onFinish"] = async (values) => {
        try {
            await dispatch(postUserCreateThunk({ ...values })).unwrap();
        } catch (e) {
            return;
        }

        navigate("/team-hr");
        notification.success({
            message: `Користувач ${values?.firstName} ${values?.lastName} створений`,
        });
    };

    return (
        <>
            <Meta title="Profile" />
            <Header title="Додавання нового користувача" back needConfirm />
            <MainContainer>
                <Form
                    form={form}
                    name="addUser"
                    style={{
                        width: "100%",
                        padding: "0 16px",
                    }}
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.Item<FieldType>
                        name="phone"
                        label="Номер телефону"
                        validateTrigger="onSubmit"
                        rules={[
                            {
                                required: true,
                                message: "Введіть номер телефону",
                            },
                            {
                                pattern: /^\+380\d{9}$/,
                                message:
                                    "Введіть номер у форматі +380 XX XXX XX XX",
                            },
                        ]}
                    >
                        <StyledInput placeholder="+38 000 000 00 00" />
                    </Form.Item>

                    <Form.Item<FieldType>
                        name="firstName"
                        label="Імʼя"
                        rules={[
                            {
                                required: true,
                                message: "Введіть імʼя",
                            },
                        ]}
                    >
                        <StyledInput placeholder="Введіть Імʼя" />
                    </Form.Item>

                    <Form.Item<FieldType>
                        name="lastName"
                        label="Прізвище"
                        rules={[
                            {
                                required: true,
                                message: "Введіть прізвище",
                            },
                        ]}
                    >
                        <StyledInput placeholder="Прізвище" />
                    </Form.Item>

                    <Form.Item<FieldType>
                        name="role"
                        label="Роль"
                        rules={[
                            {
                                required: true,
                                message: "Оберіть роль",
                            },
                        ]}
                    >
                        <StyledSelect
                            size="middle"
                            options={formList}
                            placeholder="Торговий агент"
                        />
                    </Form.Item>

                    <Form.Item<FieldType>
                        name="externalId"
                        label="ID користувача в системі партнера"
                    >
                        <StyledInput placeholder="12345678" />
                    </Form.Item>

                    <BaseButton
                        type="primary"
                        htmlType="submit"
                        marginTop="10px"
                    >
                        Зберегти
                    </BaseButton>
                </Form>
            </MainContainer>
        </>
    );
}

export default AddUser;
